import env from './env';

export function getEnvVar(name) {
    return isLocal() ? env.local[name] : env.production[name];
}

function isLocal() {
    return window.location.host.indexOf('localhost') !== -1;
}
